export default "__VITE_ASSET___UD27L9z__"